function initLogin(arg) {

    const container = document.querySelector('[data-login="container"]')
    if (!container) return

    const openNoticeLink = container.querySelector('[data-login="open-notice-link"]')

    const getCode = container.querySelector('[data-login="get-code"]')
    const enterCode = container.querySelector('[data-login="enter-code"]')
    const enterPassword = container.querySelector('[data-login="enter-password"]')
    const navigate = container.querySelector('[data-login="navigate"]')

    const enterPasswordLink = container.querySelectorAll('[data-login="enter-password-link"]')
    const enterSmsLink = container.querySelector('[data-login="enter-sms-link"]')

    const getCodeBtn = container.querySelector('[data-login="get-code-btn"]')

    const show = (elem) => elem.classList.add('show')
    const hide = (elem) => elem.classList.remove('show')

    const showEnterPassword = () => {
        hide(getCode)
        hide(enterCode)
        show(enterPassword)
        hide(navigate)
    }

    const showEnterSmsLink = () => {
        hide(getCode)
        show(enterCode)
        hide(enterPassword)
        hide(navigate)
    }

    const showGetCodeBtn = () => {
        hide(getCode)
        show(enterCode)
        hide(enterPassword)
        hide(navigate)
    }

    openNoticeLink.addEventListener('click', () => {
        show(getCode)
        hide(enterCode)
        hide(enterPassword)
        hide(navigate)
    })

    enterPasswordLink.forEach(item => {
        item.addEventListener('click', () => {
            showEnterPassword()
        })
    })

    enterSmsLink.addEventListener('click', () => {
        showEnterSmsLink()
    })

    getCodeBtn.addEventListener('click', () => {
        showGetCodeBtn()
    })

    document.addEventListener('click', (event) => {
        try {
            if (!event.target.closest('[data-login="container"]')) {
                hide(getCode)
                hide(enterCode)
                hide(enterPassword)
                hide(navigate)
            }
        } catch (e) {
            // console.log(e)
        }
    })
}